import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { usePrincipalAmortizationStore } from "../../hooks/usePrincipalAmortizationStore";
import { SearchBar } from '../loan/loanSearchBar';

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: 'flex',
    gap: '10px'
  },
  selectorFilterContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  selectorFilter: {
    width: '180px',
    marginRight: '16px',
  },
  containerBox: {
    display: 'flex',
  },
  infoItemsBox: {
    marginRight: '40px',
    marginLeft: '25px',
    display: 'flex',
    alignItems: 'center',
    gap: '30px'
  },
}));

export const PrincipalAmortizationToolbar = observer(() => {
  const classes = useStyles();
  const { principalAmortizationStore } = usePrincipalAmortizationStore();

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Toolbar
            left={
              <Grid className={classes.selectorFilterContainer}>
                <SearchBar store={principalAmortizationStore} />
              </Grid>
            }>
            <></>
          </Toolbar>
        </Grid>
      </Grid>
    </>
  );
});